export function getStoredState(key: string): { state: string; expiry: number } | null {
  const data = sessionStorage.getItem(key);
  if (!data) return null;
  return JSON.parse(data);
}

export function setStoredState(key, state: string, expiry: number): void {
  const data = { state, expiry };
  sessionStorage.setItem(key, JSON.stringify(data));
}

export function clearStoredState(key): void {
  sessionStorage.removeItem(key);
}

const ROSTERSTREAM_ENABLED_KEY = 'ENABLED_ROSTERSTREAM_SSO';
/**
 * disabled: off by default, user can manually enable it
 * enabled: on by default, user can manually disable it
 * forced: always on, cannot be disabled by the user
 */
export type RosterstreamEnabledConfig = 'disabled' | 'enabled' | 'forced';

export function isRosterstreamSSOEnabled(configSetting: RosterstreamEnabledConfig): boolean {
  if (configSetting === 'forced') return true;

  const isEnabled = localStorage.getItem(ROSTERSTREAM_ENABLED_KEY);

  if (isEnabled === null) {
    return configSetting === 'enabled';
  }

  return JSON.parse(isEnabled);
}

export function setRosterstreamSSOEnabledSetting(enabled: boolean) {
  localStorage.setItem(ROSTERSTREAM_ENABLED_KEY, JSON.stringify(enabled));
}
